import { render } from "./deleteModalQuestionnaire.vue?vue&type=template&id=95a73018"
import script from "./deleteModalQuestionnaire.vue?vue&type=script&lang=js"
export * from "./deleteModalQuestionnaire.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__